import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a0b8fc6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-4 max-w-4xl mx-auto" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl font-bold text-center mb-6 text-blue-600" }, "AI Tools for Developers", -1))
const _hoisted_3 = { class: "min-w-full table-auto border-collapse border border-blue-400" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-yellow-200" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "border border-blue-300 p-2 text-blue-700" }, "Tool"),
    /*#__PURE__*/_createElementVNode("th", { class: "border border-blue-300 p-2 text-blue-700" }, "Description"),
    /*#__PURE__*/_createElementVNode("th", { class: "border border-blue-300 p-2 text-blue-700" }, "Best Used For")
  ])
], -1))
const _hoisted_5 = { class: "border border-blue-300 p-2" }
const _hoisted_6 = { class: "border border-blue-300 p-2" }
const _hoisted_7 = { class: "border border-blue-300 p-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("table", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.aiTools, (tool) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: tool.name,
            class: "hover:bg-yellow-100"
          }, [
            _createElementVNode("td", _hoisted_5, _toDisplayString(tool.name), 1),
            _createElementVNode("td", _hoisted_6, _toDisplayString(tool.description), 1),
            _createElementVNode("td", _hoisted_7, _toDisplayString(tool.bestUsedFor), 1)
          ]))
        }), 128))
      ])
    ])
  ]))
}